import * as Yup from 'yup';

class FormHelpers {
  validationSchemaToObject = (
    validationSchema: Yup.AnySchema<Record<string, unknown> | undefined>,
    fieldName: string,
  ): Yup.TestFunction => {
    return Yup.reach(validationSchema, fieldName).describe();
  };

  isRequired = (validationSchema: Yup.AnySchema<Record<string, unknown> | undefined>, fieldName: string): boolean => {
    let schemaObject;

    try {
      schemaObject = this.validationSchemaToObject(validationSchema, fieldName);
    } catch (error) {
      return false; // If the field is not there in the schema, it means it's not required.
    }

    return schemaObject.tests.some((test) => {
      return test.name === 'required';
    });
  };

  getYearsForSelect = (startYear: number, endYear: number): { label: string; value: number }[] => {
    const years = Array.from({ length: endYear - startYear + 1 }, (v, k) => k + startYear);

    return years.map((year) => ({
      label: year.toString(),
      value: year,
    }));
  };
}

export const formHelpers = new FormHelpers();
